/*
 * File: Ufo.tsx
 * Project: meki
 * File Created: Thursday, 1st October 2020 9:46:03 am
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Thursday, 16th November 2023 5:12:11 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
import React from 'react';
import { SvgIcon } from '@mui/material';
import { styled } from '@mui/system';

export function NotFound(props) {
  const SvgIconStyled = styled(SvgIcon)(({ theme }) => ({
    margin: theme.spacing(2, 'auto'),
    width: 251,
    height: 226,
  }));
  return (
    <SvgIconStyled viewBox="0 0 251 226" {...props}>
      <defs>
        <linearGradient x1="50%" y1="100%" x2="50%" y2="0%" id="a">
          <stop stopColor="gray" stopOpacity=".3" offset="0%" />
          <stop stopColor="gray" stopOpacity=".1" offset="54%" />
          <stop stopColor="gray" stopOpacity=".1" offset="100%" />
        </linearGradient>
        <linearGradient x1="36.8%" y1="103.5%" x2="63.7%" y2="4.7%" id="b">
          <stop stopColor="gray" stopOpacity=".3" offset="0%" />
          <stop stopColor="gray" stopOpacity=".1" offset="54%" />
          <stop stopColor="gray" stopOpacity=".1" offset="100%" />
        </linearGradient>
        <linearGradient x1="36.9%" y1="103.1%" x2="63.9%" y2="4.2%" id="c">
          <stop stopColor="gray" stopOpacity=".3" offset="0%" />
          <stop stopColor="gray" stopOpacity=".1" offset="54%" />
          <stop stopColor="gray" stopOpacity=".1" offset="100%" />
        </linearGradient>
        <linearGradient x1="50%" y1="100%" x2="50%" y2="0%" id="d">
          <stop stopColor="gray" stopOpacity=".3" offset="0%" />
          <stop stopColor="gray" stopOpacity=".1" offset="54%" />
          <stop stopColor="gray" stopOpacity=".1" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <ellipse
          cx="45.5"
          cy="35.4"
          rx="45.3"
          ry="35.1"
          opacity=".8"
          transform="translate(88 6)"
          fill="url(#a)"
          fillRule="nonzero"
        />
        <ellipse fill="#004C8C" cx="133.7" cy="41.2" rx="44.3" ry="34.3" />
        <path
          d="M97 45c0-19 19-34 44-34 7 0 15 1 22 4-8-5-18-8-29-8-25 0-45 15-45 34 0 13 9 24 23 30-10-6-15-16-15-26Z"
          fill="#FFF"
          fillRule="nonzero"
          opacity=".1"
        />
        <path fill="#0277BD" opacity=".2" d="m134 55 49 85 49 85H35l50-85z" />
        <path
          d="m40 37 4-11c2-9-1-17-8-22l-4-3h-1a20 20 0 0 0-10 0h-2l-1 1h-1l-3 2c-3 2-6 6-7 9L1 31l-1 9v1l1 1v3h1l1 2 1 1v2l2 1 6 4h1c1-2 2-3 4-2l2 1h2c2-1 1-4 2-5h8l1-2 3-1c2 1 4-1 4-3l1-6Z"
          opacity=".3"
          transform="translate(106 139)"
          fill="url(#b)"
          fillRule="nonzero"
        />
        <path
          d="m119 192 3-2c2 1 3 2 5 1 1 0 0-4 3-4h6l1-2 3-1c2 1 4-1 4-3l1-6 3-11c4-9-2-20-11-23-10-4-21 2-24 11l-6 18c-3 9 2 19 11 23l1-1Z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <circle
          fill="#000"
          fillRule="nonzero"
          opacity=".2"
          cx="125.4"
          cy="150.7"
          r="2"
        />
        <circle
          fill="#000"
          fillRule="nonzero"
          opacity=".2"
          cx="136.9"
          cy="154.5"
          r="2"
        />
        <ellipse
          fill="#E0E0E0"
          fillRule="nonzero"
          transform="rotate(-71 129 160)"
          cx="128.6"
          cy="160.3"
          rx="3"
          ry="2"
        />
        <circle fill="#FFF" fillRule="nonzero" cx="170.9" cy="151.1" r="3" />
        <circle fill="#FFF" fillRule="nonzero" cx="180.5" cy="146.4" r="1.5" />
        <g opacity=".5" transform="translate(110 17)" fillRule="nonzero">
          <path
            d="m40 37 4-11c2-9-1-17-8-22l-4-3h-1a20 20 0 0 0-10-1l-1 1h-1l-1 1h-1l-3 1v1c-3 2-6 6-7 9L1 31l-1 9v1l1 1v2l1 1 1 2 1 1v1l2 2 6 4 1-1c1-1 2-2 4-1l2 1h2c2-1 1-4 2-5h8l1-2 3-1c2 1 4-1 4-3l1-6Z"
            opacity=".3"
            fill="url(#c)"
          />
          <path
            d="M13 54c1-2 3-3 4-2 1 0 3 2 4 1 2-1 1-5 4-5h1c2 1 4 2 5 0l1-2 2-1c2 1 5 0 4-2l1-6 4-11c3-10-2-21-12-24-9-3-20 2-23 12L2 31c-3 9 1 20 11 23Z"
            fill="#FFF"
          />
          <circle fill="#000" opacity=".2" cx="19.9" cy="12.1" r="2" />
          <circle fill="#000" opacity=".2" cx="31.4" cy="15.9" r="2" />
        </g>
        <path
          d="m176 31 1 7c0 19-20 34-44 34-20 0-37-10-43-24 4 15 22 27 44 27 24 0 44-15 44-34l-2-10Z"
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
        />
        <ellipse
          cx="91.9"
          cy="24"
          rx="91.6"
          ry="23.9"
          opacity=".8"
          transform="translate(42 32)"
          fill="url(#d)"
          fillRule="nonzero"
        />
        <path
          d="M134 33c-49 0-89 10-89 23h177c0-13-39-23-88-23ZM134 79c49 0 88-10 88-23H45c0 13 40 23 89 23Z"
          fill="#FFF"
          fillRule="nonzero"
        />
        <path
          d="M134 79c49 0 88-10 88-23H45c0 13 40 23 89 23Z"
          fill="#414046"
          fillRule="nonzero"
          opacity=".1"
        />
        <path
          d="M97 50h74c3 0 5 3 5 5v2c0 3-2 5-5 5H97c-3 0-6-2-6-5v-2c0-2 3-5 6-5Z"
          fill="#414046"
          fillRule="nonzero"
          opacity=".2"
        />
        <path
          d="M44 19v-1l-1-1h-1l-1 1-1 1h1v2h1l2-1h1l-1-1ZM200 114v-1l-1-1h-1l-1 1-1 1h1v2h1l2-1h1l-1-1ZM27 167l-1-1v-1h-1v1h-2v1l1 2v1l1-1h1l1-1v-1ZM9 58l-1-2H7l-2 1v1l1 1v1h1l1-1h1v-1ZM199 4c-1 0-2-1-1-2V1l-1-1-1 1-3 1-1 1 1 1 1 2 1 1h1l2-1 1-1V4Z"
          fill="#FFDC44"
          fillRule="nonzero"
        />
        <g fill="#0277BD">
          <path d="M36 85h1v6h-1z" />
          <path d="M34 87h6v1h-6z" />
        </g>
        <g fill="#0277BD">
          <path d="M247 59h1v6h-1z" />
          <path d="M244 62h6v1h-6z" />
        </g>
        <g fill="#0277BD">
          <path d="M236 151h1v6h-1z" />
          <path d="M233 154h6v1h-6z" />
        </g>
        <circle
          fill="#4FB3BF"
          fillRule="nonzero"
          cx="226.8"
          cy="29.2"
          r="2.1"
        />
        <circle fill="#4FB3BF" fillRule="nonzero" cx="2.1" cy="4.6" r="2.1" />
        <circle
          fill="#4FB3BF"
          fillRule="nonzero"
          cx="63.2"
          cy="127.6"
          r="2.1"
        />
        <ellipse
          fill="#414046"
          fillRule="nonzero"
          opacity=".1"
          cx="72.4"
          cy="48.1"
          rx="10.5"
          ry="2.2"
        />
        <ellipse
          fill="#414046"
          fillRule="nonzero"
          opacity=".1"
          cx="72.4"
          cy="64.5"
          rx="10.5"
          ry="2.2"
        />
        <ellipse
          fill="#414046"
          fillRule="nonzero"
          opacity=".1"
          cx="192.1"
          cy="48.1"
          rx="10.5"
          ry="2.2"
        />
        <ellipse
          fill="#414046"
          fillRule="nonzero"
          opacity=".1"
          cx="192.1"
          cy="64.5"
          rx="10.5"
          ry="2.2"
        />
        <ellipse
          fill="#414046"
          fillRule="nonzero"
          opacity=".1"
          cx="133.7"
          cy="38.8"
          rx="10.5"
          ry="2.2"
        />
        <ellipse
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
          cx="141.4"
          cy="16.2"
          rx="10.5"
          ry="2.2"
        />
        <ellipse
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
          cx="121.3"
          cy="25.5"
          rx="10.5"
          ry="2.2"
        />
        <ellipse
          fill="#000"
          fillRule="nonzero"
          opacity=".1"
          cx="160"
          cy="29.5"
          rx="10.5"
          ry="2.2"
        />
        <ellipse
          fill="#414046"
          fillRule="nonzero"
          opacity=".1"
          cx="133.7"
          cy="71"
          rx="10.5"
          ry="2.2"
        />
      </g>
    </SvgIconStyled>
  );
}
